export default __webpack_public_path__ + "static/media/info_mine.min.cc439223.png";